<template>
    <div class="loading_status">
        <div class="spinner"></div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.loading_status {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    overflow: hidden;
    z-index: 1000;
}

.spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px / $ppr;
    height: 200px / $ppr;
    margin-top: -100px / $ppr;
    margin-left: -100px / $ppr;
    background: url("./img/loadingS.gif") no-repeat;
    background-size: 100% 100%;
}
</style>
